<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12">
          <h1 class="font-semibold text-2xl lg:text-3xl text-center">
            Review
          </h1>
          <section class="mt-12">
            <div v-if="progressLoading" class="text-center text-gray-600 my-2 p-5">
              <Spinner class="mx-auto" orange/>
            </div>
            <div v-else-if="categories.length === 0" class="text-center text-gray-600 my-2 p-5">No categories selected
            </div>
            <div v-else>
              <div>
                <p class="ml-4">Average Estimated Cost Per Attendee:<span class="ml-2 text-primary"> <strong
                    class="text-xl font-bold text-black"> ${{
                    this.total_price
                  }}</strong></span>
                </p>
              </div>

              <div v-for="(category, index) in categories" :key="category.uuid"
                   :class="{'border-b border-gray-300': index < categories.length - 1}"
                   class="py-5">
                <div class="flex flex-row items-center px-2 md:px-4 cursor-pointer group">
                  <div
                      class="w-16 h-16 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                    <LightBox :img="category.image">
                      <img :src="category.image" alt="Order Details Page"/>
                    </LightBox>
                  </div>
                  <div class="ml-4 min-w-0 mt-3 w-full">

                    <div class="flex justify-between w-full">
                      <span class="font-semibold text-primary">{{ category.title }}</span>
                      <!--                      <span class="block ml-auto text-primary"> <strong-->
                      <!--                          class="text-xl font-bold text-black">${{-->
                      <!--                          category.average_price-->
                      <!--                        }}</strong> / attendee</span>-->
                    </div>

                    <div class="flex">
                      <div>
                        <span class="block">{{ shorten(category.name, 150) }}</span>
                      </div>

                      <button v-show="canEditCategory(category)"
                              class="px-2 py-1 ml-2 invisible group-hover:visible flex-shrink-0"
                              @click="onClickEditCategory(category)">
                        <img alt="BuildaBox Order Details Page" src="@/assets/icons/edit-pencil.svg"/>
                      </button>

                    </div>
                    <div class="text-gray-600 truncate mt-1">{{ shorten(category.description, 150) }}</div>
                  </div>
                </div>
                <div class="mt-4 md:ml-10">
                  <div v-if="category.items && category.items.length > 0" class="">
                    <draggable v-model="category.items" :draggable="canEditCategory(category) ? '.line-item' : false"
                               handle=".draggable-handler"
                               @update="onUpdateSort(category, category.items)">
                      <div v-for="item in category.items" :key="item.uuid" class="line-item">
                        <div class="flex flex-row items-center py-4 cursor-pointer group">
                          <button class="btn ml-3 draggable-handler mr-4 flex-shrink-0">
                            <img alt="BuildaBox Order Process" src="@/assets/icons/ic_drag.svg"/>
                          </button>
                          <div
                              class="w-12 h-12 rounded bg-gray-600 overflow-hidden flex items-center justify-center flex-shrink-0">
                            <LightBox :img="item.image">
                              <img :src="item.image" alt="BuildaBox Order Details Page"/>
                            </LightBox>
                          </div>
                          <div class="ml-4 min-w-0 w-full">
                            <div class="flex w-full">
                              <div class="flex justify-between w-full">
                                <span class="font-semibold text-primary">{{ item.name }}</span>
                                <!--                                <span class="block ml-auto text-primary"> <small-->
                                <!--                                    class="text-lg font-normal text-black">${{-->
                                <!--                                    item.price-->
                                <!--                                  }} X {{ item.quantity }} = ${{ item.multiple_price }}</small> / attendee</span>-->
                              </div>
                              <button v-show="canEditCategory(category)"
                                      class="px-2 py-1 ml-2 invisible group-hover:visible flex-shrink-0"
                                      @click="onClickEditItem(item)">
                                <img alt="BuildaBox Order Details Page" src="@/assets/icons/edit-pencil.svg"/>
                              </button>
                            </div>
                            <div class="text-gray-600 truncate mt-1">{{ shorten(item.description, 150) }}</div>
                          </div>
                        </div>
                      </div>
                    </draggable>
                  </div>
                  <div v-else class="text-center text-gray-600 my-2 p-5"></div>
                </div>
              </div>
            </div>
          </section>
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <button
                  :disabled="!canProceedToNextStep"
                  class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                  @click="$emit('submit')"
              >
                <span>Next</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Modal v-if="selectedCategory">
      <div slot="modal-wrapper">
        <div class="flex justify-center p-2">
          <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-3xl">
            <OrderCategoryEditor
                :category="selectedCategory"
                :order-uuid="order.uuid"
                @cancel="selectedCategory = ''"
                @submit="selectedCategory = ''; loadCategories()"
            />
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-if="selectedItem">
      <div slot="modal-wrapper">
        <div class="flex justify-center p-2">
          <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-3xl">
            <OrderLineItemEditor
                :categories="categories"
                :line-item="selectedItem"
                :order="order"
                @cancel="selectedItem = ''"
                @submit="selectedItem = ''; loadCategories()"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Modal from '@/components/common/Modal'
import OrderCategoryEditor from '@/components/OrderCategoryEditor'
import OrderLineItemEditor from '@/components/OrderLineItemEditor'
import Spinner from '@/components/common/Spinner'
import Api from '@/api/api_v1.0'
import { ORDER_MENU_TYPE } from '@/utils/order-menu-type'
import LightBox from '@/components/common/LightBoxComponent.vue'

export default {
  components: {
    Spinner,
    OrderLineItemEditor,
    OrderCategoryEditor,
    Modal,
    draggable,
    LightBox,
  },
  data () {
    return {
      progressLoading : false,
      categories      : [],
      selectedCategory: '',
      selectedItem    : '',
      total_price     : 0,
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    canProceedToNextStep () {
      return true
    },
    userCategories () {
      return this.categories.filter(category => category.type !== ORDER_MENU_TYPE.BUILDABOX)
    }
  },
  async mounted () {
    await this.loadCategories()
  },
  methods: {
    async loadCategories () {
      this.progressLoading = true

      let orderType = (parseInt(this.order.process) == 1) ? ORDER_MENU_TYPE.CUSTOM : ORDER_MENU_TYPE.ALL
      await Api.getCategoriesForOrder(this.order.uuid, orderType).then(response => {
        this.progressLoading = false

        this.categories = response
            .filter(category => category.items.length > 0)
            .map(category => {
              this.total_price += category.estimated_price
              return category
            })
        this.total_price = Math.round((this.total_price + Number.EPSILON) * 100) / 100
      }).catch(() => {
        this.progressLoading = false
      })
    },
    shorten (str, size) {
      return str.length <= size ? str : str.slice(0, size) + '...'
    },
    canEditCategory (category) {
      return category.type !== ORDER_MENU_TYPE.BUILDABOX
    },
    onClickEditCategory (category) {
      this.selectedCategory = JSON.parse(JSON.stringify(category))
    },
    onClickEditItem (item) {
      this.selectedItem = JSON.parse(JSON.stringify(item))
    },
    onUpdateSort (category, items) {
      const ids = items.map(item => item.uuid)
      Api.sortLineItemsForOrder(this.order.uuid, category.uuid, ids)
    }
  }
}
</script>